import { type UseQueryResult, useQuery } from 'react-query';
import { WarrantParticipantService } from '../../services/wealthlane-captable-services';

const useGetWarrantDocuments = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  warrantId: string,
  enabled: boolean = true
): UseQueryResult<any[] | undefined, unknown> => {
  return useQuery(
    ['getWarrantDocuments', warrantId],
    async () => {
      return await handleRequest(
        WarrantParticipantService.getApiCapTableApiAppWarrantParticipantParticipantWarrantDocuments(
          warrantId
        )
      );
    },
    { enabled: enabled && !!warrantId }
  );
};

export default useGetWarrantDocuments;
